import { render, staticRenderFns } from "./mianze_mini.vue?vue&type=template&id=64da0313&scoped=true&"
import script from "./mianze_mini.vue?vue&type=script&lang=js&"
export * from "./mianze_mini.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64da0313",
  null
  
)

export default component.exports